import React, { memo, useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import quagga from "@ericblade/quagga2"
import { DEFAULT_CONFIG } from "./utils"
import { makeStyles } from "@material-ui/core/styles"
import CircularProgress from "@material-ui/core/CircularProgress"

const useStyles = makeStyles(() => ({
	container: {
		border: "#0000",
		display: "flex",
		height: "400px",
	},
	// Global styles for the video element within the container
	"@global": {
		video: {
			width: "100% ",
		},
	},
	circularProgress: { position: "absolute", top: "50%", left: "45%" },
}))

const ReactQuagga = memo(({ onClose, onDetected: handleDetected, onError: handleError }) => {
	const quaggaRef = useRef(null)
	const styles = useStyles()
	const [loadingSpinner, setLoadingSpinner] = useState(true)

	useEffect(() => {
		const activeConfig = DEFAULT_CONFIG
		const { inputStream: initAttrs } = activeConfig
		initAttrs["target"] = quaggaRef.current

		quagga.init({ ...activeConfig, inputStream: initAttrs }, (error) => {
			if (error) {
				if (handleError) {
					handleError(error)
				}
				return
			}

			setLoadingSpinner(false)
			quagga.start()
		})

		quagga.onDetected((data) => {
			// Call onDetected with the detected data
			if (handleDetected && onClose) {
				handleDetected(data)
				onClose()
			}
		})

		return () => {
			quagga.offDetected(handleDetected)
			quagga.stop()
		}
		// eslint-disable-next-line
	}, [])

	return (
		<>
			{loadingSpinner && <CircularProgress className={styles.circularProgress} size={50} thickness={1} />}
			<div ref={quaggaRef} className={styles.container} />
		</>
	)
})

ReactQuagga.displayName = "ReactQuagga"

ReactQuagga.propTypes = {
	onClose: PropTypes.func,
	onDetected: PropTypes.func.isRequired,
	onProcessed: PropTypes.func,
	onError: PropTypes.func,
	config: PropTypes.object,
	nodeIdEntered: PropTypes.string,
}

export default ReactQuagga
